import { Ticket } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const FONT_B = { fontFamily: "'Manrope', sans-serif" };

export function AccessCodeSection() {
  const navigate = useNavigate();

  return (
    <div className="mt-8 pt-6 border-t border-gray-100">
      <button
        onClick={() => navigate('/joinpool')}
        className="w-full flex items-center justify-center gap-2 text-sm font-semibold py-3 rounded-xl border-2 border-dashed border-gray-200 text-gray-500 hover:border-gray-300 hover:text-gray-700 transition-all"
        style={FONT_B}
        data-testid="auth-access-code-link"
      >
        <Ticket className="w-4 h-4" /> I have an Access Code
      </button>
    </div>
  );
}
